/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountNativeDetailsBaseForAws extends models.ServiceAccountNativeDetailsBaseForCloud {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountNativeDetailsBaseForAws");
    }

    getFixupPrototypeFunction() { return ServiceAccountNativeDetailsBaseForAws.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountNativeDetailsBaseForAws>): ServiceAccountNativeDetailsBaseForAws {
        let obj = Object.assign(new ServiceAccountNativeDetailsBaseForAws(), model);
        ServiceAccountNativeDetailsBaseForAws.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountNativeDetailsBaseForAws>): ServiceAccountNativeDetailsBaseForAws {
        if (!model) return null;
        return ServiceAccountNativeDetailsBaseForAws.newInstance(<ServiceAccountNativeDetailsBaseForAws> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountNativeDetailsBaseForAws) {
        if (!obj) return;

        models.ServiceAccountNativeDetailsBaseForAws.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountNativeDetailsBaseForAws): boolean {
        if (models.ServiceAccountNativeDetailsBaseForCloud.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountNativeDetailsBaseForAws.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.default_values) {
            models.SelfServiceDefaultValuesForAws.fixupPrototype(this.default_values);
        }
    }

    /**
     * Account Id
     */
    account_id: string;

    /**
     * Account Name
     */
    account_name: string;

    /**
     * Aws Cloud Type. This is a required field.
     */
    cloud_type: models.AwsCloudType;

    /**
     * Preferred Regions List By User. This is a required field.
     */
    regions: Array<string>;

    /**
     * SelfService Default Values
     */
    default_values: models.SelfServiceDefaultValuesForAws;

    /**
     * Cost Report access
     */
    cost_report_access: models.AwsCostReportAccess;

    /**
     * S3 Bucket Name or URI that is configured in Cost Usage Report
     */
    bucket_name_or_uri: string;

    /**
     * Whether custom billing processing applicable or not
     */
    custom_billing_required: boolean;

    /**
     * Link to Service Account that is used to retrieve billing information for AWS GovCloud Account.
     */
    commercial_account_id: string;

    /**
     * AWS Account ID of the standard account in which the billing data for the GovCloud account is stored (via S3 access key and secret key).
     */
    standard_account_id: string;

    /**
     * S3 Bucket Name or URI that is configured for Cost Usage Report Aggregation
     */
    aggregated_bucket_name_or_uri: string;

}
